<template>
  <div>
    <app-board bodyClass="p-3">
      <template slot="leftContent">
        <h5 class="border-bottom p-3">Testing Panel Setting / User Setting</h5>
      </template>
      <panelSettingForm :editMode="false" :onCreateCallback="addNewUserSetting"></panelSettingForm>
    </app-board>

    <div class="mt-5" v-if="userPanelSetting.length > 0 && usersList.length && fusionList.length">
      <app-board :header="false" class="p-3 mt-3" v-for="(setting, index) in userPanelSetting" :setting="setting" :key="index">
        <panelSettingForm :autoBind="true" :dataToBind="setting" :bindingForView="true"  :recordId="setting.id" :editMode="true"></panelSettingForm>
      </app-board>
    </div>
  </div>
</template>

<script>

export default {
  components: {
    panelSettingForm: () => import('./../form/View.vue')
  },
  data () {
    return {
      userPanelSetting: []
    }
  },
  computed: {
    ...$mapState('user-state', ['usersList']),
    ...$mapState('voip-testing-panel-setting-state', ['fusionList'])
  },
  beforeMount() {
    this.getUsersSettingRecords().then( (r) => {
      this.userPanelSetting = r.data
    })
  },
  methods: {
    ...$mapActions('voip-testing-panel-user-setting-api', { getUsersSettingRecords: 'getUsersSettingRecords'}),
    addNewUserSetting (setting) {
      this.userPanelSetting.push(setting)
    }
  }
}
</script>
